module.exports = __webpack_public_path__ + "static/media/kubernetes.b7e51e84.png";